"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ERROR_LOG_CACHE_KEY } from "@/src/lib/data-fetchers/error-log-fetchers";
import { invalidateTaskCaches } from "@/src/lib/data-fetchers/tasks-fetchers";
import { retryReferralExport } from "@/src/requests/referral-export";

export function useRetryReferralExport(task: { id: string; displayId: string | null }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => retryReferralExport(task.id),
    onSettled: async () => {
      await Promise.all([
        invalidateTaskCaches(queryClient, task),
        queryClient.invalidateQueries({ queryKey: [ERROR_LOG_CACHE_KEY, task.id] }),
      ]);
    },
  });
}
